import { Box, Card, Container, Typography } from '@material-ui/core';
import { Loader, SGSForm, SGSIcon, SGSTooltip } from 'components';
import SGSFormAutoComplete from 'components/Form/AutoComplete';
import { useAppContext } from 'core/contexts';
import { menusService, documentationService } from 'core/services';
import { useQueryConf } from 'core/utils/useQuery';
import { AnyKindOfDictionary } from 'lodash';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { makeStyles } from '@material-ui/core/styles';
import iconDocument from '../../../assets/document.svg';
import classNames from 'classnames';

type Props = {};

const useStyles = makeStyles(() => ({
    txt: {
        color: '#4F7793',
        fontFeatureSettings: 'clig off, liga off',
        fontFamily: 'Open Sans',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1rem' /* 652% */,
        textTransform: 'uppercase',
    },
    row: {
        '&:hover': {
            background: '#F7F8FB',
            cursor: 'pointer',
        },
        borderBottom: '1px solid #E1E3E7',

        display: 'flex',
        alignItems: 'center',

        height: '40px',
    },
    notification: {
        color: '#4F7793',
        fontFeatureSettings: 'clig off, liga off',
        fontFamily: 'Open Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '1rem',
        textTransform: 'uppercase',
        textAlign: 'center',
    },
    icon: {
        color: '#3399DB',
        cursor: 'pointer',
        width: '30px',
        height: '30px',
    },
}));

const DocumentationPageList: React.FC<Props> = () => {
    const { t } = useTranslation();
    const { user } = useAppContext();
    const classes = useStyles();
    const [selectedOption, setSelectedOption] = useState(null);
    const [documents, setDocuments] = useState<any>();
    const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);

    const { isLoading: isLoadingSouscripteurs, data: dataSouscripteurs } = useQuery([user.login, 'souscripteurs'], async () => await menusService.getMenuSouscripteurs(), useQueryConf);

    const methods = useForm();

    const loadDocuments = async () => {
        setIsLoadingDocuments(true);
        const docs = await documentationService.getDocumentation(selectedOption.value);
        setDocuments(docs);
        setIsLoadingDocuments(false);
    };

    useEffect(() => {
        if (selectedOption) loadDocuments();
        else {
            setDocuments(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption]);

    // Download report
    const handleDownlaodReport = (id: any, link: AnyKindOfDictionary) => {
        documentationService.getDocument(id, link).then((response: any) => {
            const byteCharacters = atob(response.document);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const url = window.URL.createObjectURL(new Blob([byteArray], { type: response.content_type }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', response.name);
            document.body.appendChild(link);
            link.click();
        });
    };

    // const handleSeeDocument = (id: any, link: AnyKindOfDictionary) => {
    //     documentationService.getDocument(id, link).then((response: any) => {
    //         const byteCharacters = atob(response.document);
    //         const byteNumbers = new Array(byteCharacters.length);

    //         for (let i = 0; i < byteCharacters.length; i++) {
    //             byteNumbers[i] = byteCharacters.charCodeAt(i);
    //         }

    //         const byteArray = new Uint8Array(byteNumbers);
    //         const blob = new Blob([byteArray], { type: response.content_type });
    //         const a = document.createElement('a');
    //         a.download = response.name;
    //         a.href = window.URL.createObjectURL(blob);
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //     });
    // };

    const hasDocument = () => {
        if (documents && documents.length) return true;
        return false;
    };

    return (
        <Container>
            <Card style={{ minHeight: '600px' }}>
                <Box className="mt-5">
                    <Typography component={'h1'} className="text-center">
                        Liste des documents disponibles
                    </Typography>
                </Box>
                <Box className="mt-3">
                    <FormProvider {...methods}>
                        <SGSForm.Card shadow={false}>
                            <SGSForm.Row>
                                <SGSForm.Col>
                                    <SGSFormAutoComplete
                                        variant="outlined"
                                        name="souscripId"
                                        label="contract.documentation.subscriber"
                                        options={dataSouscripteurs}
                                        loading={isLoadingSouscripteurs}
                                        handleChange={setSelectedOption}
                                    />
                                </SGSForm.Col>
                            </SGSForm.Row>
                        </SGSForm.Card>
                    </FormProvider>
                </Box>
                {hasDocument() && !isLoadingDocuments && (
                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, mb: 5 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Box className=" mt-0" style={{ width: '800px' }}>
                            {documents &&
                                documents.map((d) => {
                                    return (
                                        <Box display={'flex'} flexDirection={'row'} className={classes.row} onClick={() => handleDownlaodReport(d.id, d.link)}>
                                            <Box className="mr-3">
                                                <img src={iconDocument} alt={''} />
                                            </Box>
                                            <Box className={classes.txt} flexGrow={'1'}>
                                                {d.name}
                                            </Box>
                                            {/* <Box className={classNames(classes.icon, 'm-1 ml-3')} onClickCapture={() => handleSeeDocument(d.id, d.link)}>
                                                <SGSTooltip className="text-center" title={<Box>{t('global.consult')}</Box>}>
                                                    <SGSIcon icon="fas fa-eye" />
                                                </SGSTooltip>
                                            </Box> */}
                                            <Box className={classNames(classes.icon, 'm-1 ml-3')} onClickCapture={() => handleDownlaodReport(d.id, d.link)}>
                                                <SGSTooltip className="text-center" title={<Box>{t('global.download')}</Box>}>
                                                    <SGSIcon icon="fas fa-download" />
                                                </SGSTooltip>
                                            </Box>
                                        </Box>
                                    );
                                })}
                        </Box>
                        <Box sx={{ flex: '1 1 auto' }} />
                    </Box>
                )}
                {isLoadingDocuments && <Loader loading={true} small></Loader>}

                {!selectedOption && !isLoadingDocuments && <Box className={classes.notification}>Sélectionner un souscripteur pour obtenir la liste des documents disponibles</Box>}
                {selectedOption && documents && !documents.length && !isLoadingDocuments ? <Box className={classes.notification}> Aucun document</Box> : ''}
            </Card>
        </Container>
    );
};

export default DocumentationPageList;
